import { render, staticRenderFns } from "./GlobalDeliveryNetworkSingle.vue?vue&type=template&id=75186811&"
import script from "./GlobalDeliveryNetworkSingle.vue?vue&type=script&lang=js&"
export * from "./GlobalDeliveryNetworkSingle.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDeliveryNetworkSingle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports